import { render, staticRenderFns } from "./main-navigation-item.vue?vue&type=template&id=1934f412&"
import script from "./main-navigation-item.vue?vue&type=script&lang=ts&"
export * from "./main-navigation-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "main-navigation-item.vue"
export default component.exports